if(!customElements.get('added-to-cart-popup')){
    class AddedToCartPopup extends HTMLElement {
        constructor(){
            super();

            this.form = this.querySelector('form');
            this.duration = this.dataset.duration? parseInt(this.dataset.duration) * 1000 : 10000;
            this.timeoutRunning = false;

            this.template = this.querySelector('#template-added-to-cart-item');
            this.cartItemsWrapper = this.querySelector('.cart-items-wrapper');

            // Das Formular wird serverseitig mit der Klasse "disabled" gerendert, damit ein
            // leeres Popup nicht abgesendet werden kann. Der Submit-Handler unten blockiert
            // solange jeden Klick auf "Zur Kasse". Entfernt wurde die Klasse bisher nirgends,
            // deshalb war der Button dauerhaft wirkungslos. openPopup()/closePopup() pflegen
            // den Zustand jetzt.
            this.form.addEventListener('submit', e => {
                if(this.form.classList.contains('disabled')){
                    e.preventDefault();
                }
            })

            // close popup
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.closePopup.bind(this));
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter') this.closePopup();
                });
            });
            this.addEventListener('click', e => {
                if(e.target === this) this.closePopup();
            });
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE') this.closePopup();
            });

            this.adjustTopPosition();
            window.addEventListener('scroll', () => {
                this.adjustTopPosition();
            });
        }

        adjustTopPosition(){
            const sectionHeaders = Array.from(
                document.querySelectorAll('.section-header')
            );
            let topPosition = 0;
            sectionHeaders.some((item) => {
                const headerElement = item.querySelector('.header-element');
                const style = getComputedStyle(headerElement);

                if(headerElement === this){
                    return true;
                }else{
                    topPosition =
                        topPosition +
                        headerElement.offsetHeight +
                        parseFloat(style.marginTop);
                }
            });

            const header = document.querySelector('custom-header');
            if(header){
                const scroll = header.dataset.scroll === 'true';
                const sticky = header.dataset.sticky === 'scroll' || (header.dataset.sticky === 'scroll-up' && scroll);
                const scrollTop = header.dataset.scrollTop === 'true';

                if(!scrollTop){
                    if(sticky){
                        if(scroll){
                            topPosition = header.offsetHeight + parseFloat(getComputedStyle(header).marginTop);
                        }
                    }else{
                        topPosition = 0;
                    }
                }
            }

            this.style.top = `${topPosition}px`;
        }

        openPopup(){
            this.previouslyFocusedElement = this.pendingTriggerElement || document.activeElement;
            this.pendingTriggerElement = null;

            // FIX: Popup ist offen und enthaelt einen Artikel -> Absenden erlauben.
            this.form?.classList.remove('disabled');

            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');

            this.addFocus();

            if(this.timeoutRunning){
                clearTimeout(this.popupSetTimeout);
            }

            setTimeout(() => {
                const cartItems = this.querySelectorAll('.cart-item');

                cartItems.forEach(item => {
                    item.setAttribute('data-hidden', 'false');
                });
            }, 300);

            this.timeoutRunning = true;
            this.popupSetTimeout = setTimeout(() => {
                this.closePopup();
                this.timeoutRunning = false;
            }, this.duration);
        }  

        closePopup(){
            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');
            this.cartItemsWrapper.innerHTML = '';

            // FIX: Popup ist leer und geschlossen -> Absenden wieder sperren.
            this.form?.classList.add('disabled');

            if(this.previouslyFocusedElement){
                setTimeout(() => {
                    this.previouslyFocusedElement.focus();
                }, 300);
            }
        }

        addFocus(){
            setTimeout(() => {
                const focusItems = this.querySelectorAll('a');

                if(focusItems.length > 0){
                    focusItems[0].focus();
                }
            }, 100);
        }

        renderContent(product, triggerElement = null){
            this.pendingTriggerElement = triggerElement || document.activeElement;

            if(product){
                const template = this.template.content.cloneNode(true);
                const imageWrapper = template.querySelector('.image-wrapper');
                const vendor = template.querySelector(".vendor");
                const heading = template.querySelector(".heading");
                const variant = template.querySelector('.variant');
                const links = template.querySelectorAll('.cart-item a');
                const cartItem = template.querySelector('.cart-item');

                if(product.image && imageWrapper){
                    const img = Object.assign(document.createElement('img'), {
                        src: product.image,
                        alt: product.title,
                    });
                    img.className = 'w-full h-full object-cover';

                    imageWrapper.innerHTML = '';
                    imageWrapper.appendChild(img);
                }

                if(product.title && heading){
                    heading.innerHTML = product.title;
                }

                if(product.vendor && vendor){
                    vendor.innerHTML = product.vendor;
                }

                links.forEach(item => {
                    item.setAttribute('href', product.url);
                    item.setAttribute('title', product.title);
                    item.setAttribute('aria-label', product.title);
                });

                if(product.variant_options && variant){
                    variant.innerHTML = `${product.variant_options.join(', ')}`;
                }

                cartItem.setAttribute('data-product-id', product.id);
                this.cartItemsWrapper.appendChild(template);


                setTimeout(() => {
                    this.cartItemsWrapper.querySelector(`.cart-item[data-product-id="${product.id}"]`)?.remove();
                }, this.duration + 100);

                this.openPopup();
                this.updateCartSize();
            }
        }

        updateCartSize(){
            const cartIconURL = `/?section_id=header-cart-icon`;
            fetch(cartIconURL)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
                return res.text();
            }).then(text => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

                const header = document.querySelector('custom-header');
                const cartSizeIcons = header?.querySelectorAll('.cart-item-size');
                if(cartSizeIcons.length > 0){
                    cartSizeIcons.forEach(item => {
                        item.innerText = `${resultsMarkup.trim()}`;
                        item.setAttribute('aria-hidden', 'false');
                    });
                }
            }).catch(e => {
                console.error(e);
            })
        }
    }

    customElements.define('added-to-cart-popup', AddedToCartPopup);
}